var CodeEditorLanguages = /*#__PURE__*/ function(CodeEditorLanguages) {
    CodeEditorLanguages["Css"] = "css";
    CodeEditorLanguages["Html"] = "markup";
    CodeEditorLanguages["Javascript"] = "js";
    return CodeEditorLanguages;
}({});

export { CodeEditorLanguages };
//# sourceMappingURL=code-editor.js.map
